export enum ScoreGridCategory {
  Customer = 'Customer',
  Speed = 'Speed',
  Teamwork = 'Teamwork',
  Excellence = 'Excellence',
  Innovation = 'Innovation',
  HumanValues = 'HumanValues',
}
